module.exports = __webpack_public_path__ + "zarustajici-nehty_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/zarustajici-nehty_4_before_tn.jpg
// module id = 1512
// module chunks = 0